import { FC, RefObject } from 'react';
import styled, { css } from 'styled-components';
import { PreviewSize } from '@vs-online-only-app/ui';

interface PreviewProps {
  $sending: boolean;
  $size: PreviewSize;
}

const previewStyles = css<PreviewProps>`
  border-radius: inherit;
  width: 100%;
  object-fit: cover;

  ${({ $size }) =>
    $size === PreviewSize.Small &&
    css`
      height: 80px;
      width: 80px;
    `}

  ${({ $size }) =>
    $size === PreviewSize.Large &&
    css`
      min-height: 200px;
      max-height: 320px;
    `};

  ${({ $sending }) =>
    $sending &&
    css`
      filter: blur(4px);
    `}
`;

const VideoPreview = styled.video<PreviewProps>`
  ${previewStyles}
`;

const ImagePreview = styled.img<PreviewProps>`
  ${previewStyles}
`;

type Props = {
  size: PreviewSize;
  mediaType: 'image' | 'video';
  url: string;
  onLoadedData: () => void;
  onLoadedMetadata: () => void;
  sending: boolean;
  videoRef: RefObject<HTMLVideoElement>;
};

export const MediaPreview: FC<Props> = ({
  mediaType,
  url,
  onLoadedData,
  onLoadedMetadata,
  size,
  sending,
  videoRef,
}) => {
  if (mediaType === 'video') {
    return (
      <VideoPreview
        src={url}
        title="Video thumbnail"
        onLoadedData={onLoadedData}
        onLoadedMetadata={onLoadedMetadata}
        ref={videoRef}
        $size={size}
        $sending={Boolean(sending)}
      />
    );
  }

  return (
    <ImagePreview
      src={url}
      onLoad={onLoadedData}
      $size={size}
      $sending={Boolean(sending)}
    />
  );
};
